import { Routes } from "../../methods/ApiRoutes";
const shared = {
  title: 'Content Management',
  addTitle: 'Content',
  route: 'content-management',
  listApi: 'content/listing',
  detailApi: 'content/detail',
  addApi: 'content/add',
  editApi: 'content/update',
  deleteApi: 'content/delete',
  route: "content-management",

  ...Routes.Content,


};

export default shared;

